import React, { useContext, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { GlobalContext } from "../context/GlobalContext";
import { makeStyles } from "@mui/styles";
import UserInfo from "./UserInfo";
import UserCard from "./UserCard";
import UserRatingsDetailed from "./UserRatingsDetailed";
import TeamDashboard from "./TeamDashboard";
import Skeleton from "@mui/material/Skeleton";
import { useAuth } from "components/context/auth";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    flexGrow: 1,
    padding: theme.spacing(6, 0),
    paddingTop: theme.spacing(13),
    boxSizing: "border-box",
    padding: "48px 0px",
    boxSizing: "border-box",
    paddingTop: "104px",
    backgroundColor: "rgba(245, 244, 242, 0.6)",
    "& > *": {
      padding: "30px",
      display: "flex-grid",
      [theme.breakpoints.down("md")]: {
        padding: "0",
      },
    },
  },
  firstGrid: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: "1rem",
    },
  },
  profile: {
    backgroundColor: "transparent",
  },
  dashboard: {
    maxWidth: 1300,
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 0
  }
}));

const UserProfile = () => {
  const { user, setUser } = useAuth();
  const appState = useContext(GlobalContext);
  const { updateUserAvatar } = appState;
  const [isVerified, setIsVerified] = useState(false);
  const [dateCreated, setDateCreated] = useState("");
  /*Profile data*/
  const [email, setEmail] = useState("");
  const [picture, setPicture] = useState("");
  const [name, setName] = useState("");
  const [profileData, setProfileData] = useState("");

  useEffect(() => {
    setEmail(profileData.email);
    setPicture(profileData.picture);
    setName(profileData.fullname);
  }, [profileData]);

  useEffect(() => {
    if (user) {
      setProfileData(user);
      if (user.verifiedDT) {
        setIsVerified(true);
      }
      if (user.createdAt) {
        setDateCreated(user.createdAt);
      }
    }
  }, [user]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
        className={classes.dashboard}
      >
        <Grid item className={classes.firstGrid}>
          <Grid item>
            <div className="profile--layout_userInfo">
              {user ? (
                <Grid item>
                  <UserCard
                    picture={picture}
                    userEmail={email}
                    name={name}
                    isVerified={isVerified}
                    dateCreated={dateCreated}
                    currentUser={user}
                    updateUserAvatar={updateUserAvatar}
                    setUser={setUser}
                    user={user}
                  />
                  <UserInfo profileData={profileData} setName={setName} />
                </Grid>
              ) : (
                <Grid item style={{ padding: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      margin: "100px 100px 100px 100px",
                    }}
                  >
                    <Skeleton variant="circular" width={115} height={115} aria-label="Profile Picture"/>
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                  <div style={{ marginTop: "1rem" }}>
                    <Skeleton variant="rectangular" />
                  </div>
                </Grid>
              )}
            </div>
          </Grid>
        </Grid>
        <div className="profile-left-container">
          <Grid item>
            <div className="profile--layout_ratings_reviews_block">
              <TeamDashboard currentUser={user} isVerified={isVerified} />
              <UserRatingsDetailed userEmail={email} />
            </div>
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default UserProfile;
